module.exports = __webpack_public_path__ + "assets/img/api-key.bcfd7c8d.svg";